import React from 'react';
import Link from 'components/link';
import { Form, Field, Button } from 'components/form';
import { FadeInUp } from 'components/transitions';
import SwellLogo from 'components/logo/logo';
import LoginPageLeftPart from 'components/login/left-part';
import './login.scss';

export default class RecoverPage extends React.PureComponent {
  render() {
    const {
      params,
      onSubmitRecover,
      defaultValues,
      isPartnerLogin = false,
    } = this.props;
    const isReset = Boolean(params.resetKey);

    return (
      <div className="auth-split">
        <LoginPageLeftPart isPartnerLogin={isPartnerLogin} />
        <div className="auth-split_panel">
          <Link className="auth-toplink" to="/login">
            Login instead
          </Link>
          <div className="auth-split_form auth-form-fields">
            <div className="logo-container">
              <SwellLogo />
            </div>

            <FadeInUp>
              <div>
                <div className="auth-recover-heading">
                  {isReset ? (
                    <>
                      <h2>Reset password</h2>
                      <p>Enter a new password to access your account</p>
                    </>
                  ) : (
                    <>
                      <h2>Recover password</h2>
                      <p>
                        Enter your email address and we&rsquo;ll send
                        <br />
                        instructions to reset your password
                      </p>
                    </>
                  )}
                </div>
                {/* Keyed so switching modes in place (expired reset key →
                    email form) remounts the form instead of carrying the
                    typed password into the email field */}
                <Form
                  key={isReset ? 'reset' : 'email'}
                  onSubmit={onSubmitRecover}
                >
                  <fieldset>
                    {isReset ? (
                      <Field
                        type="password"
                        name="password"
                        label="New password"
                        rules="required, password_admin"
                        placeholder="***********"
                        large={true}
                        validateIcon={true}
                        className="login-form-field-margin-24"
                      />
                    ) : (
                      <Field
                        type="text"
                        name="email"
                        label="Email"
                        rules="required, email"
                        defaultValue={defaultValues.username}
                        large={true}
                        validateIcon={true}
                        className="login-form-field-margin-24"
                      />
                    )}
                  </fieldset>
                  <div className="login-actions">
                    <Button type="submit" styleType="default" size="large">
                      {isReset ? 'Save password' : 'Recover password'}
                    </Button>
                  </div>
                </Form>
              </div>
            </FadeInUp>
          </div>
        </div>
      </div>
    );
  }
}
